import React,{Component} from 'react';
import './NabarClient.css';
import {NavLink , Link} from 'react-router-dom';
import logoblue from '../../../../image/logoblue.png'

class NabarClient extends Component{

    render(){
        return(
<div className="  h-100 text-center   bg-white shadow">
<div className="navclient   text-center h-100 ">
    <ul className="navbar-nav p-0 text-uppercase" >
                         <li className="nav-item ">
                            <Link to="/AR/"><img className="logo mt-3 mb-4" src={logoblue} alt="kayn" /></Link>
                        </li>
                        <li className="nav-item ">
                            <NavLink to="/AR/NewOrder" className="iconnav "><div className="iconneworder mx-auto"></div><p className="fontsize15">طلب جديد</p></NavLink>
                        </li>                            

                        <li className="nav-item ">
                            <NavLink to="/AR/Orders" className="iconnav "><div className="iconorders  mx-auto">  </div><p className="fontsize15">الطلبات</p></NavLink>
                        </li>
                        <li className="nav-item ">
                            <NavLink to="/AR/MyClients" className="iconnav "><div className="iconclient  mx-auto"></div><p className="fontsize15">عملائي</p></NavLink>
                        </li>
                        <li className="nav-item ">
                            <NavLink to="/AR/ClientAdderss" className="iconnav "><div className="iconaddressbook   mx-auto"></div><p className="fontsize15">العناوين</p></NavLink>
                        </li>
                        <li className="nav-item ">
                            <NavLink to="/AR/Wallet" className="iconnav "><div className="iconwallet  mx-auto"></div><p className="fontsize15">المحفظه</p></NavLink>
                        </li>
    </ul>
</div>
</div>

        )
    }
}
export default NabarClient;